const state = () => ({
    current_duration: 0,
    all_duration: 0
})

const mutations = {
    setCurrentDuration(state, { time }) {
        state.current_duration = time
    },
    setAllDuration(state, { time }) {
        state.all_duration = time
    }
}

const actions = {
    async setCurrentDuration({ commit }, { time }) {
        commit('setCurrentDuration', { time })
    },
    async setAllDuration({ commit }, { time }) {
        commit('setAllDuration', { time })
    }
}

const getters = {
    current_duration: state => state.current_duration,
    all_duration: state => state.all_duration,
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};